/*eslint no-unused-vars: ["error", { "args": "none" }]*/
import { IDENTITY_CONFIG, METADATA_OIDC } from "./authConst";
import { UserManager, WebStorageStateStore } from "oidc-client";
import {
    getLastNonAuthPath,
    getRelativeUrl,
    isAuthFlowPath,
    rememberLoginRedirectPath
} from "./authRedirect";

export default class AuthService {
    UserManager;
    oidcStorageKey;
    constructor() {        
        this.oidcStorageKey = `oidc.user:${IDENTITY_CONFIG.authority}:${IDENTITY_CONFIG.client_id}`;
        this.UserManager = new UserManager({
            ...IDENTITY_CONFIG,
            userStore: new WebStorageStateStore({ store: window.sessionStorage }),
            metadata: { ...METADATA_OIDC }
        });
        
        // Logger
        // Log.logger = console;
        // Log.level = Log.DEBUG;
                
        this.UserManager.events.addUserLoaded((user) => {
            if (window.location.href.indexOf("signin-oidc") !== -1) {
                this.navigateToScreen();
            }
        });
        
        this.UserManager.events.addSilentRenewError((e) => {
            console.log("silent renew error", e.message);
        });

        this.UserManager.events.addAccessTokenExpired(() => {
            console.log("token expired");
            this.signinSilent();
        });
    }

    sendLog = async (oidcStorage) => {        
        console.log('after login oidcStorage', oidcStorage);
        const URL = `/api/v1.0/account/log/`;
        const headers = new Headers();
        headers.append("Content-Type", "application/json");
        headers.append("Accept", "application/json");
        headers.append("Authorization", `Bearer ${oidcStorage.access_token}`);                                
        fetch(URL, { method: "GET", headers: headers })
            .then(response =>  {                
                console.log(response);
            });
                // .then(data => {                    
                //     console.log('sendLog', data);
                // });
    };

    signinRedirectCallback = () => {
        this.UserManager.signinRedirectCallback()
        // do something after successful authentication
        .then(() => {
            const oidcStorage = JSON.parse(sessionStorage.getItem(this.oidcStorageKey))            
            if(oidcStorage){
                this.sendLog(oidcStorage);                
            }

            // window.location.replace("/");
        })
        // do something if there was an error
        .catch(() => {
          // window.location.replace("/");
        });
    };

    // signinRedirectCallback = () => {
    //     this.UserManager.signinRedirectCallback().then(() => {
    //         "";
    //     });
    // };

    signinPopup = () => {
        this.UserManager.signinPopup();
    };
      
    signinPopupCallback = () => {
        this.UserManager.signinPopupCallback();
    };

    getUser = async () => {
        if(!this.UserManager)
            return null;        
        const user = await this.UserManager.getUser();        
        // if (!user) {
        //     return await this.UserManager.signinRedirectCallback();
        // }
        return user;
    };

    parseJwt = (token) => {
        const base64Url = token.split(".")[1];
        const base64 = base64Url.replace("-", "+").replace("_", "/");
        return JSON.parse(window.atob(base64));
    };

    signinRedirect = () => {
        const currentPath = getRelativeUrl(window.location);
        const redirectPath = isAuthFlowPath(currentPath)
            ? getLastNonAuthPath()
            : currentPath;

        rememberLoginRedirectPath(redirectPath);
        this.UserManager.signinRedirect({});
    };

    navigateToScreen = () => {
        window.location.replace("/");
    };

    isAuthenticated = () => {
        const oidcStorage = JSON.parse(sessionStorage.getItem(this.oidcStorageKey))

        return (!!oidcStorage && !!oidcStorage.access_token)
    };

    signinSilent = () => {
        this.UserManager.signinSilent()
            .then((user) => {
                console.log("signed in", user);
            })
            .catch((err) => {
                console.log(err);
            });
    };

    signinSilentCallback = () => {
        this.UserManager.signinSilentCallback();
    };

    createSigninRequest = () => {
        return this.UserManager.createSigninRequest();
    };

    logout = () => {
        this.UserManager.signoutRedirect({
            id_token_hint: localStorage.getItem("id_token")
        });
        this.UserManager.clearStaleState();
    };

    signoutRedirectCallback = () => {
        this.UserManager.signoutRedirectCallback().then(() => {
            localStorage.clear();
            // eslint-disable-next-line no-undef
            // window.location.replace(process.env.REACT_APP_API_DOMAIN);
        });
        this.UserManager.clearStaleState();
    };
}
